import React from 'react';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { getNumberOfSeparations, getSeparationPath } from '../Helpers';
import { WorksheetsResultsMessagesSection } from '../../Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';

// Section that brings together messages from other parts of the worksheet that need to be shown in the results section.
let ResultsMessagesSection: React.FC<IWorksheetComponent> = ({ prefixName, createWorksheetSelector }) => {
  const separationCount = useSelector(pipe(createWorksheetSelector!('', false), getNumberOfSeparations));

  // Each separation has a coarse portion sieving to contextualise
  let contextCaptions = Array(separationCount)
    .fill(undefined)
    .map((_, i) => ({
      path: prefixName!(`${getSeparationPath(i)}.CoarsePortion`),
      caption: i > 0 ? `Portion ${i + 1}` : `Coarse Portion`,
    }));

  // The final separation has a fine portion sieving to contextualise
  if (separationCount > 0)
    contextCaptions.push({
      path: prefixName!(`${getSeparationPath(separationCount - 1)}.FinePortion.Subspecimen`),
      caption: 'Fine Portion',
    });

  return <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />;
};

ResultsMessagesSection = withInjectedProps(ResultsMessagesSection);

export { ResultsMessagesSection };
export default ResultsMessagesSection;
